import script from "./NodeExpressBlog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeExpressBlog.vue?vue&type=script&setup=true&lang=ts"

import "./NodeExpressBlog.vue?vue&type=style&index=0&id=5302dc4f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5302dc4f"]])

export default __exports__